import { postFetch as r, getFetch as i, deleteFetch as c } from "../requests/request-methods.js";
class h {
  baseUrl = "";
  subscriptionKey = void 0;
  setBaseUrl(e) {
    this.baseUrl = e;
  }
  setBaseConfig(e) {
    this.baseUrl = e.url, this.subscriptionKey = e.subscriptionKey;
  }
  async httpPost(e, t) {
    const s = t?.headers || {};
    return s["Ocp-Apim-Subscription-Key"] = this.subscriptionKey, r(this.baseUrl + e, t?.body, s);
  }
  async httpGet(e, t) {
    const s = t?.headers || {};
    return s["Ocp-Apim-Subscription-Key"] = this.subscriptionKey, i(this.baseUrl + e, s);
  }
  async httpDelete(e, t) {
    const s = t?.headers || {};
    return s["Ocp-Apim-Subscription-Key"] = this.subscriptionKey, c(this.baseUrl + e, s);
  }
}
const n = new h();
export {
  n as default
};
